import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import cookie from "react-cookies";
import { Modal, ModalHeader, ModalBody, ModalFooter, Alert } from "reactstrap";

import logo from "../Posti_Group.svg.png";
import { userActions, alertActions, msgActions } from "../../../redux/actions";
import "./LoginApp.css";

class LoginApp extends Component {
  state = {
    username: "",
    password: "",
    submitted: false,
    errorText: "",
    loaderMask: {
      show: false,
      text: "",
    },
    modal: false,
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitted: true });
    const { username, password } = this.state;
    const { dispatch } = this.props;
    if (username && password) {
      dispatch(userActions.login(username, password));
    }
  };

  componentDidMount() {
    if (window.NTT.NTTLoader) {
      setTimeout(function () {
        if (window.NTT.NTTLoader) {
          window.NTT.NTTLoader.increment = 1;
          window.NTT.NTTLoader.intervalTime = 200;
          window.NTT.NTTLoader.loadStep("Almost there! 3, 2, 1...", 85, 100);
        }
      }, 500);
      setTimeout(function () {
        if (window.NTT.NTTLoader) {
          window.NTT.NTTLoader.hideLoader();
        }
      }, 1700);
    }
    let params = {
      ConfigItemId: "UMS_RESET_PASSWORD_URL",
    };
    axios
      .get("Configuration/GetConfigItem", { params: params })
      .then((response) => {
        let data = response.data;
        if (data) {
          if (typeof data === "object") {
            if (data.Errors && data.Errors.length) {
              this.props.dispatch(
                msgActions.error("Get Config Item", data.Errors[0])
              );
            }
          } else if (typeof data === "string") {
            window.ForgetPasswordUMSLink = data;
          }
        }
      });
    this.userNameInput && this.userNameInput.focus();
    const { dispatch, history } = this.props;
    history.listen((location, action) => {
      // clear alert on location change
      dispatch(alertActions.clear());
    });
  }

  toggleModal = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  navToUserManagementSys = () => {
    if (window.ForgetPasswordUMSLink) {
      window.open(window.ForgetPasswordUMSLink, "_blank");
    } else {
      this.props.dispatch(
        msgActions.error("UMS link error", "UMS link is not available")
      );
    }
    this.setState({
      modal: !this.state.modal,
    });
  };

  handleForgetPassClick = (e) => {
    e.preventDefault();
    this.toggleModal();
  };

  toggleMsgBox = () => {
    this.props.dispatch(msgActions.clear());
  };

  render() {
    const { loggingIn, alert, loaderMask, history } = this.props;
    const { username, password } = this.state;
    if (
      localStorage.getItem("PortalUserSettings") &&
      cookie.load("AuthToken")
    ) {
      if (loaderMask.show) {
        setTimeout(function () {
          var _oldHash = localStorage.getItem("LastLocationHash");
          let _lastLocHash = _oldHash ? _oldHash.toString() : "";
          let _search = localStorage.getItem("LastLocationHashSearch") || "";
          //history.push(_lastLocHash);
          if (_lastLocHash) {
            history.push({
              pathname: _lastLocHash,
              search: _search,
            });
          }
        }, 1000);
      } else {
        var _oldHash = localStorage.getItem("LastLocationHash");
        let _lastLocHash = _oldHash ? _oldHash.toString() : "";
        let _search = localStorage.getItem("LastLocationHashSearch") || "";
        if (_lastLocHash) {
          return (
            <Redirect
              to={{
                pathname: _lastLocHash,
                search: _search,
              }}
            />
          );
        } else {
          return (
            <Redirect
              to={{
                pathname: "files",
              }}
            />
          );
        }
      }
    }

    return (
      <div className="loginPageComponent container-fluid fill p_login">
        {loaderMask.show && (
          <div className="opus_loader">
            <div className="lds-spinner">
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
            </div>
            <div className="lds-text">{loaderMask.text}</div>
          </div>
        )}
        <div className="fill">
          <div
            className="top navbar navbar-fixed-top overHidden"
            role="navigation"
          >
            <div className="row w-100">
              <div className="col-lg-12 text-center">
                <img
                  className="logo"
                  alt="Posti"
                  src={logo}
                  style={{
                    width: "130px",
                  }}
                />
                <span
                  className="navbar-brand-text"
                  style={{
                    width: "130px",
                    color: "#fff",
                    float: "none",
                    verticalAlign: "bottom",
                    lineHeight: "47px",
                  }}
                >
                  Messaging
                </span>
              </div>
            </div>
          </div>
          <div className="contentHeight">
            <div id="content" className="row content fill">
              <div className="w-100">
                <div
                  className="row fill align-items-center"
                  style={{ display: "flex" }}
                >
                  <div className="main-login">
                    <form
                      name="form"
                      className="form-horizontal"
                      id="loginGroup"
                      autoComplete="off"
                      onSubmit={this.handleSubmit}
                    >
                      <h2>Login</h2>
                      <div style={{ margin: "25px 0 10px 0" }}>
                        Please enter your username and password to log in
                      </div>
                      <div
                        id="ExError"
                        className="form-group"
                        style={{ color: "#ff5b5b" }}
                      >
                        {alert.message}
                      </div>
                      <div className="form-group">
                        <label
                          htmlFor="username"
                          className="cols-sm-2 control-label"
                          style={{ marginBottom: "2px" }}
                        >
                          Username
                        </label>
                        <input
                          type="text"
                          name="username"
                          id="username"
                          placeholder="Enter your Username"
                          ref={(input) => {
                            this.userNameInput = input;
                          }}
                          value={username}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div
                        className="form-group"
                        style={{ marginBottom: "25px" }}
                      >
                        <label
                          htmlFor="password"
                          className="cols-sm-2 control-label"
                          style={{ marginBottom: "2px" }}
                        >
                          Password
                        </label>
                        <input
                          type="password"
                          name="password"
                          id="password"
                          placeholder="Enter your Password"
                          value={password}
                          onChange={this.handleChange}
                        />
                      </div>
                      <button
                        disabled={loggingIn}
                        className={
                          "btn btn-lg btn-block login-button" +
                          (loggingIn ? " loading" : "")
                        }
                      >
                        Login
                      </button>
                      <button
                        id="changePasswordBtn"
                        onClick={this.handleForgetPassClick}
                        className="forget-pass"
                      >
                        Forgot password
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer overHidden d-lg-block">
            <div className="mt-2 text-center">
              © <span id="companyYear">{new Date().getFullYear()}</span> Posti
              Messaging
            </div>
            <div className="version">
              Version: {window.NTT && window.NTT.version}
            </div>
          </div>
        </div>
        <Modal
          style={{ maxWidth: "600px" }}
          isOpen={this.state.modal}
          toggle={this.toggleModal}
        >
          <ModalHeader toggle={this.toggleModal}>Forgot password</ModalHeader>
          <ModalBody>
            An external application User Management System
            (https://ums.itella.com) will be opened in separate tab after
            pressing button "Navigate to User Management System.
          </ModalBody>
          <ModalFooter className="text-center">
            <button
              type="button"
              className="btn btn-secondary hidden-small-screen"
              onClick={this.toggleModal}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.navToUserManagementSys}
            >
              Navigate to User Management System
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={!!this.props.msg.type} toggle={this.toggleMsgBox}>
          <ModalHeader toggle={this.toggleMsgBox}>
            {this.props.msg.header}
          </ModalHeader>
          <ModalBody>
            <Alert color={this.props.msg.type}>{this.props.msg.message}</Alert>
          </ModalBody>
          <ModalFooter className="text-center">
            <button
              type="button"
              className="switchBtn"
              style={{ width: "100px" }}
              onClick={this.toggleMsgBox}
            >
              OK
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loggingIn, isSubUser } = state.authentication;
  const { alert, loaderMask, msg } = state;
  return {
    loggingIn,
    alert,
    msg,
    loaderMask,
    isSubUser,
  };
}

const connectedLoginPage = connect(mapStateToProps)(LoginApp);
export { connectedLoginPage as LoginPage };
